import { PageTransition, StaggerItem } from '../app/page-transition.js';
import { HeroSection } from './hero-section.js';
import { PrincipleQuote } from './principle-quote.js';
import { AgentDemoSection } from './agent-demo-section.js';
import { AgentInputDemoSection } from './agent-input-demo-section.js';
import { EditorDemoSection } from './editor-demo-section.js';
import { PricingSection } from './pricing-section.js';
import { BlogShowcaseSection } from './blog-showcase-section.js';
import { LandingHead } from './landing-head.js';

export function LandingPage() {
  return (
    <PageTransition>
      <LandingHead />
      <div className="relative">
        <StaggerItem>
          <HeroSection />
        </StaggerItem>
        <StaggerItem>
          <PrincipleQuote />
        </StaggerItem>
        <StaggerItem>
          <AgentDemoSection />
        </StaggerItem>
        <StaggerItem>
          <AgentInputDemoSection />
        </StaggerItem>
        <StaggerItem>
          <EditorDemoSection />
        </StaggerItem>
        <StaggerItem>
          <PricingSection />
        </StaggerItem>
        <StaggerItem>
          <BlogShowcaseSection />
        </StaggerItem>
      </div>
    </PageTransition>
  );
}
